import { useQuery } from "@tanstack/react-query";

import { FETCH_ERROR } from "../consts/fetch-error";
import { useLocale } from "../stores/locale";
import { useGetAuthContext } from "./get-auth-context";

export function useGetAssociationContext() {
  const { currentLanguage } = useLocale();
  const { data: authContext } = useGetAuthContext();

  return useQuery({
    queryKey: ["association-context", currentLanguage, authContext?.id],
    queryFn: () => {
      if (authContext?.type === "association") {
        return authContext;
      }
      if (authContext?.type === "associationUser") {
        return authContext.association;
      }

      throw new Error("Invalid auth context");
    },
    staleTime: 1000 * 60 * 60, // 1 hour
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}
